import { type ReactNode } from 'react';
import { useTranslation } from 'next-i18next';
import { QuestionTooltip } from '@/shared/components';
import { cn } from '@/utils/tailwind.util';
export const VoucherTableHeader = () => {
  const {
    t
  } = useTranslation(['billing']);
  return <>
      <div className="flex h-[52px] w-full items-start">
        <Cell content={t('voucher.table.status')} className="w-[80px] py-[14px] mobile-lg:max-w-[160px]" data-sentry-element="Cell" data-sentry-source-file="VoucherTableHeader.tsx" />
        <Cell content={t('voucher.table.voucherName')} className="min-w-[160px] mobile-lg:min-w-[240px]" data-sentry-element="Cell" data-sentry-source-file="VoucherTableHeader.tsx" />
        <Cell content={t('voucher.table.plan')} className="py-[14px] mobile-lg:max-w-[160px]" data-sentry-element="Cell" data-sentry-source-file="VoucherTableHeader.tsx" />
        <Cell content={<span className="flex items-center gap-3xs">
              <span className="text-body-md-semibold text-neutral">
                {t('voucher.table.deadline')}
              </span>
              <QuestionTooltip content={t('voucher.table.deadlineTooltip')} tooltipClassName="max-w-[210px]" />
            </span>} className="w-[120px] py-[14px] mobile-lg:max-w-[180px]" data-sentry-element="Cell" data-sentry-source-file="VoucherTableHeader.tsx" />
        <Cell content={t('voucher.action.activate')} className="py-[14px] mobile-lg:max-w-[160px]" data-sentry-element="Cell" data-sentry-source-file="VoucherTableHeader.tsx" />
      </div>

      {/* Divider */}
      <div className="my-3xs h-px w-full border-t border-alternative" />
    </>;
};
export const Cell = ({
  content,
  className
}: {
  content: ReactNode;
  className?: string;
}) => {
  return <div className={cn('flex h-full shrink-0 items-center px-sm', 'w-[100px] mobile-lg:min-w-[100px] mobile-lg:flex-1', className)} data-sentry-component="Cell" data-sentry-source-file="VoucherTableHeader.tsx">
      {typeof content === 'string' ? <span className="text-body-md-semibold text-neutral">{content}</span> : content}
    </div>;
};